import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import ExpandIcon from '../../assets/images/Expand Arrow1.png';

import { createTransferUtoUService, getTransferUtoUService  } from "../../services/transfer.service";

const UserToUserHistory = () => {
    const [transferData, setTransferData] = useState([]);
    const [startDate, setStartDate] = useState(
        new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split('T')[0]
    );
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

    const [showDatePicker, setShowDatePicker] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        getTransferUtoUData(signal);

        return () => {
            controller.abort();
        }
    },[]);

    // const handleBetweenDate = async () => {
    //     const controller = new AbortController();
    //     const signal = controller.signal;
    //     getTransferUtoUData(startDate, endDate, signal);

    //     return () => {
    //         controller.abort();
    //     }
    // }

    const getTransferUtoUData = async (startDate, endDate, signal) => {
        dispatch(setIsLoading(true))

        try {
            if(startDate && endDate) {
                const result = await getTransferUtoUService(signal); //(startDate, endDate, signal)
                if(result.data) {
                    setTransferData(result.data)
                }
            }
            else {
                const result = await getTransferUtoUService(signal);
                if(result.data) {
                    setTransferData(result.data)
                }
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
        dispatch(setIsLoading(false))
        }
    }

    // const groupedData = transferData && transferData.reduce((acc, current) => {
    //     // const date = current.transferDate.value.split('T')[0];
    //     const date = new Date(current.dateTime.value).toLocaleDateString();
    //     if (!acc[date]) {
    //         acc[date] = [];
    //     }
    //     acc[date].push(current);

    //     return acc;
    // }, {});

    // const sortedGroupedData = Object.fromEntries(
    //     Object.entries(groupedData).sort(([, a], [, b]) => b.length - a.length)
    // );

    // const datePickerPanel = () => {
    //     return (
    //         <div className='flex justify-end items-center gap-2 w-[90%] h-32 mb-5 mx-auto'>
    //             <div className='flex flex-col justify-center items-center gap-2'>
    //                 <div className='w-[100%] h-[100%]'>
    //                     <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className='w-[100%] h-[100%] border-2 border-gray-300 rounded-md px-2 py-1 outline-none' />
    //                 </div>
    //                 <div className='w-[100%] h-[100%]'>
    //                     <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className='w-[100%] h-[100%] border-2 border-gray-300 rounded-md px-2 py-1 outline-none' />
    //                 </div>
    //                 <button onClick={() => handleBetweenDate()} className='w-[100%] h-[100%] bg-primary text-white rounded-md px-5 py-1.5'>
    //                     Find
    //                 </button>
    //             </div>
    //         </div>
    //     )
    // }

    return (
        <div>
            <div className='bg-white rounded-sm h-[90dvh] mx-2 my-2'>
                <div className='w-[100%] h-[90%]'>

                    <div className='flex justify-between w-[90%] pt-10 pb-5 mx-auto'>
                        <h1 className='text-lg text-userText font-semibold'>» Transfer User to User History «</h1>
                        {/* <img src={ExpandIcon} alt="" onClick={() => setShowDatePicker(!showDatePicker)} className='w-6 h-6 cursor-pointer' /> */}
                    </div>

                    {/* {showDatePicker && datePickerPanel()} */}

                    <div className="w-[90%] h-[90%] text-sm font-normal mx-auto  overflow-y-auto">
                        {   transferData.length > 0 ?
                            <table className='w-full md:w-[100%] mx-auto text-fgColor font-semibold'>

                            <tbody>
                                    { transferData.map((transfer, idx) => (
                                            <tr className="border-b-2 border-borderColor" key={idx}>
                                                <td className="w-[45%] text-primary font-semibold text-left py-3 px-3 md:px-5 h-12">
                                                    <div>{transfer.sender} <span className='text-red'>[to]</span> {transfer.recipient}</div>
                                                    <div className='text-xs text-textcol'>{transfer.dateTime ? new Date(transfer.dateTime.value).toLocaleDateString() : 'Invalid Date'}</div>
                                                </td>
                                                <td className="w-[25%] text-left md:px-5 h-12 overflow-hidden">
                                                    <div className='text-xs'>{transfer.description}</div>
                                                </td>
                                                <td className="w-[25%] text-right md:px-5 h-12 overflow-hidden">
                                                    <div>{transfer.transactionType}</div>
                                                    <div>{transfer.amount.toLocaleString()}</div>
                                                </td>
                                            </tr>
                                    ))}
                            </tbody>
                        </table>
                    :
                        <div className='w-full h-full flex items-center justify-center font-semibold'>
                            <h1 className='text-lg'>No Data To Show</h1>
                        </div>
                    }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserToUserHistory
